import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Lucky15ResultBody from '../../../casinoComponents/refResultModal/Lucky15ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

// Reference LastResultsSection (lucky15): win 1..6 → 0, 1, 2, 4, 6, W
const WIN_LABELS = { 1: '0', 2: '1', 3: '2', 4: '4', 5: '6', 6: 'W' };

/**
 * Last Result items for Lucky 15 in the reference markup (inside `.casino-video-last-results`):
 * <span class="resultb">{label}</span>. Click → full-page .loader-overlay while the round detail
 * loads, then the reference result modal (ball + rdesc).
 */
const ResultLucky15 = ({ data = [], gameType = 'lucky15' }) => {
  const apiType = (gameType || 'lucky15').toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        if (Array.isArray(response?.data?.data?.res)) {
          setLastResults(response.data.data.res.map((item) => ({ mid: item.mid, win: String(item.win ?? '') })));
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (item) => {
    if (!item?.mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, item.mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error fetching detail results:', error);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  // API results; before they arrive, the feed's lrs as a fallback
  const items = lastResults.length > 0
    ? lastResults
    : (Array.isArray(data) ? data : []).map((r) =>
        typeof r === 'object' && r ? { mid: r.mid, win: String(r.win ?? '') } : { mid: null, win: String(r) }
      );

  return (
    <>
      {items.map((item, index) => (
        <span key={item.mid || index} className="resultb" onClick={() => handleResultClick(item)}>
          {WIN_LABELS[item.win] ?? ''}
        </span>
      ))}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || 'Lucky 15'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Lucky15ResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultLucky15;
